import type { Theme } from '@ltvco/refresh-lib/theme';
export interface RepairEstimateVehicleData {
  year?: number;
  make?: string;
  model?: string;
  trim?: string;
  incidents: number;
  titleIssues: number;
  marketValue: number;
  mileage?: number;
}

export const buildRepairEstimateData = (
  isFreePlan: boolean,
  vehicleData: RepairEstimateVehicleData,
  location: string,
  repairDescription: string,
  shopQuote: string | null,
  userMileage?: number,
): string => {
  const repairData = {
    year: vehicleData.year,
    make: vehicleData.make,
    model: vehicleData.model,
    trim: vehicleData.trim,
    location: location,
    repair_description: repairDescription,
    shop_quote: shopQuote || null,
    mileage: userMileage ?? vehicleData.mileage ?? undefined,
    market_value: vehicleData.marketValue ?? undefined,
    ...(!isFreePlan && {
      incidents: vehicleData.incidents,
      title_issues: vehicleData.titleIssues,
    }),
  };

  // Remove undefined values
  Object.keys(repairData).forEach((key) => {
    if (repairData[key as keyof typeof repairData] === undefined) {
      delete repairData[key as keyof typeof repairData];
    }
  });

  return JSON.stringify(repairData);
};

export const getUrgencyColor = (urgencyLevel: string, theme: any): string => {
  switch (urgencyLevel.toLowerCase()) {
    case 'high':
      return theme.palette.error.main;
    case 'medium':
      return theme.palette.warning.main;
    case 'low':
      return theme.palette.success.main;
    default:
      return theme.palette.text.secondary;
  }
};

export const getDifficultyColor = (
  difficultyLevel: number,
  theme: Theme,
): string => {
  if (difficultyLevel <= 3) {
    return theme.palette.success.main;
  } else if (difficultyLevel <= 6) {
    return theme.palette.warning.main;
  } else {
    return theme.palette.error.main;
  }
};
